import { render, staticRenderFns } from "./sellersCards.vue?vue&type=template&id=00af1662&"
import script from "./sellersCards.vue?vue&type=script&lang=js&"
export * from "./sellersCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports